import showForm from "./showForm";

/**
 * 转发 bos 平台相关指令
 */
export default function sendBosPlatformEvent(pageId, payload) {
  if (!window.spyApi || !window.spyApi.doPostActions) {
    console.error('Current page is not a bos page');
    throw new Error('Current page is not a bos page');
  }

  if (!Array.isArray(payload) || payload.length === 0) {
    console.error('Payload must be an array');
    throw new Error('Payload must be an array');
  }

  for (let _payload of payload) {
    const { a: action, p: param } = _payload
    window.spyApi.doPostActions(pageId, action, param);
  }
}

async function showFormRequest(formConfig, config = {}) {
  const response = await showForm(formConfig, config);
  if (!response) {
    throw new Error('showForm response is not valid');
  }

  const { parentPageId, pageId } = formConfig;
  const payload = response;
  const pId = pageId || parentPageId;
  sendBosPlatformEvent(pId, payload);
}

export {
  showFormRequest as showForm
}